// extracted by mini-css-extract-plugin
export default {"shadowed":"App_shadowed__to0t7","dark":"App_dark__SSbXf","light":"App_light__xZVXn"};